import { useQuery } from '@tanstack/react-query';
import { agentsApi, AIAgentResponse } from '../services/agentsApi';

/**
 * Hook para buscar um agente específico por ID
 *
 * @example
 * const { data: agent, isLoading, error } = useAgent('agent-id-123');
 */
export const useAgent = (id?: string) => {
  return useQuery<AIAgentResponse, Error>({
    queryKey: ['ai-agent', id],
    queryFn: () => agentsApi.getById(id!),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
